import { SearchInput } from 'react-admin';
import * as React from 'react';

const SearchFields = [
  <SearchInput source="q" alwaysOn color={'info'} sx={{ width: '100%' }} />,
];

export default SearchFields;
